var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_535",
    "data-name": "Grupo 535",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.013,
    height: 22.013,
    viewBox: "0 0 22.013 22.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2145",
    "data-name": "Caminho 2145",
    d: "M79.965,224.747a5.723,5.723,0,1,0-5.3-5.707A5.521,5.521,0,0,0,79.965,224.747Zm0-9.783a4.087,4.087,0,1,1-3.785,4.076A3.943,3.943,0,0,1,79.965,214.964Z",
    transform: "translate(-68.959 -213.333)",
    fill: "#fafafa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2146",
    "data-name": "Caminho 2146",
    d: "M19.458,386.333A18.36,18.36,0,0,0,11.006,384a18.36,18.36,0,0,0-8.451,2.334A4.92,4.92,0,0,0,0,390.693v.746a2.3,2.3,0,0,0,2.246,2.344h17.52a2.3,2.3,0,0,0,2.246-2.344v-.746A4.919,4.919,0,0,0,19.458,386.333Zm.983,5.106a.7.7,0,0,1-.674.713H2.246a.7.7,0,0,1-.674-.713v-.746a3.285,3.285,0,0,1,1.707-2.912,16.83,16.83,0,0,1,7.727-2.15,16.831,16.831,0,0,1,7.727,2.15,3.285,3.285,0,0,1,1.707,2.912Z",
    transform: "translate(0 -371.77)",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.845c89030c28a0aad898ab69b667571d.svg";
export { ForwardRef as ReactComponent };